var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "u8-steps-component", attrs: { flex: "" } },
    _vm._l(_vm.steps, function (step, index) {
      return _c(
        "div",
        {
          key: index,
          staticClass: "u8-step-item",
          attrs: { "flex-box": index === _vm.steps.length - 1 ? 0 : 1 },
        },
        [
          _c(
            "div",
            {
              staticClass: "u8-step-item__wrapper",
              class: {
                "u8-step-item__active": _vm.currStep === index + 1,
                "u8-step-item__complete": _vm.currStep > index + 1,
              },
            },
            [
              _c("div", { attrs: { flex: "" } }, [
                _c(
                  "div",
                  {
                    staticClass: "u8-step-item__title",
                    attrs: { "flex-box": "0" },
                  },
                  [
                    _c("span", { staticClass: "u8-step-num" }, [
                      _vm.currStep <= index + 1
                        ? _c("i", [_vm._v(_vm._s(index + 1))])
                        : _vm._e(),
                      _vm.currStep > index + 1
                        ? _c("i", { staticClass: "el-icon-check" })
                        : _vm._e(),
                    ]),
                    _c("span", { staticClass: "u8-step-title" }, [
                      _vm._v(_vm._s(step)),
                    ]),
                  ]
                ),
                index < _vm.steps.length - 1
                  ? _c("div", { attrs: { "flex-box": "1" } }, [
                      _c("div", { staticClass: "u8-step-item__divider" }),
                    ])
                  : _vm._e(),
              ]),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }